module.exports = __webpack_public_path__ + "img/7.35404825.jpg";